import * as React from "react"
import { BsFillPlayFill } from "react-icons/bs"
import styled from "@emotion/styled"
import type { RoomBranding } from "../../../recoil/atoms/room/types"
import { Flex } from "@chakra-ui/react"
import { brandingSelector } from "../../../recoil/atoms/room"
import { useRecoilValue } from "recoil"

interface StylesProps {
  roomStyles?: RoomBranding
}

interface PollArrowsProps {
  containerRef: React.RefObject<HTMLDivElement>
  pollId: string
}

const UpIcon = styled(BsFillPlayFill)<StylesProps>`
  color: rgba(0, 0, 0, 0.2);
  stroke-width: 1;
  stroke: ${({ roomStyles }) => roomStyles?.overlayEmojiStrokeColor ?? "white"};
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transform: ${() => "rotate(-90deg) translate(-20%, 0%)"};
`
const DownIcon = styled(BsFillPlayFill)<StylesProps>`
  color: rgba(0, 0, 0, 0.2);
  stroke-width: 1;
  stroke: ${({ roomStyles }) => roomStyles?.overlayEmojiStrokeColor ?? "white"};
  cursor: pointer;
  transform: ${() => "rotate(90deg) translate(20%, 0%)"};
  -webkit-tap-highlight-color: transparent;
`

export const PollArrows: React.FC<PollArrowsProps> = ({
  containerRef,
  pollId
}) => {
  const roomStyles = useRecoilValue(brandingSelector)
  const scrollDistance = 20
  const [scrollIntervalId, setScrollIntervalId] = React.useState(null)

  const handleScrollToUp = () => {
    const container = containerRef.current
    const distance: number =
      container.scrollTop - scrollDistance >= 0
        ? container.scrollTop - scrollDistance
        : 0

    container.scrollTop = distance
  }

  const handleScrollToBottom = () => {
    const container = containerRef.current
    const distance: number =
      container.scrollTop + scrollDistance >=
      container.scrollHeight - container.clientHeight
        ? container.scrollHeight - container.clientHeight
        : container.scrollTop + scrollDistance

    container.scrollTop = distance
  }

  const onTouchStartUp = () => {
    handleScrollToUp()
    if (scrollIntervalId === null) {
      setScrollIntervalId(
        setInterval(() => {
          handleScrollToUp()
        }, 150)
      )
    }
  }

  const onTouchStartDown = () => {
    handleScrollToBottom()
    if (scrollIntervalId === null) {
      setScrollIntervalId(
        setInterval(() => {
          handleScrollToBottom()
        }, 150)
      )
    }
  }

  const onTouchEnd = () => {
    if (scrollIntervalId !== null) {
      clearInterval(scrollIntervalId)
      setScrollIntervalId(null)
    }
  }

  return (
    <Flex bottom="20px" left="2px" pos="absolute" flexDirection="column">
      <UpIcon
        onTouchEnd={onTouchEnd}
        onTouchStart={onTouchStartUp}
        id={`arrow-up-${pollId}`}
        roomStyles={roomStyles}
        size="2rem"
        onMouseDown={e => e.preventDefault()}
      />
      <DownIcon
        onTouchStart={onTouchStartDown}
        onTouchEnd={onTouchEnd}
        id={`arrow-down-${pollId}`}
        roomStyles={roomStyles}
        size="2rem"
        onMouseDown={e => e.preventDefault()}
      />
    </Flex>
  )
}
